import React, { Component } from 'react'
import CardForm from 'Utils/Cards/CardForm';
import LoadMask from 'Utils/LoadMask/LoadMask';
import MensajeForm from './MensajeForm';

export default class MensajeCrear extends Component {

    componentWillMount(){
        if(this.props.match.params.id){
            this.props.leer(this.props.match.params.id);
        }
    }

    onSubmit = (values) => {
        const { crear, editar } = this.props;

        if (this.props.match.params.id) {
            editar(this.props.match.params.id, values);
        } else {
            crear(values);
        }

    }

    render() {
        const { loader } = this.props;
        return (
            <div className="mb-4 col-12 mt-4">
                <CardForm>
                    <LoadMask loading={loader} blur>
                        <MensajeForm onSubmit={this.onSubmit}/>
                    </LoadMask>
                </CardForm>
            </div>
        )
    }
}
